export enum Scopes {
	READ_PRODUCTS = 'read:products',
	CREATE_PRODUCTS = 'create:products',
	UPDATE_PRODUCTS = 'update:products',
	DELETE_PRODUCTS = 'delete:products',

	READ_SHOPS = 'read:shops',
	UPDATE_SHOPS = 'update:shops',

	CREATE_ORDERS = 'create:orders',
	READ_ORDERS = 'read:orders',
	UPDATE_ORDERS = 'update:orders',
	DELETE_ORDERS = 'delete:orders',
}

export const API_DOCS_URL = 'https://api.rentle.io/docs';
export const ApiDocsTagUrl = (tag: string) => API_DOCS_URL + '#tag/' + tag;
